import React from 'react';
import LoginForm from './LoginForm';
import PasswordResetRequestForm from './PasswordResetRequestForm';
import StandardModal from '../../Shared/UI/StandardModal/components/StandardModal';
import StepWizard from 'react-step-wizard';

import { useEffect } from 'react';
import { useLoginWizardActions } from './LoginWizardContext';
import { useHeaderState, useHeaderActions } from '../../Header/components/HeaderContext';

const LoginWizardContent = () => {
  const state = useHeaderState();
  const { closeLoginWizard } = useHeaderActions();

  return (
    <>
      <StandardModal
        isOpen={state?.loginWizardOpen}
        onRequestClose={closeLoginWizard}
      >
        <StepWizard transitions={{}}>
          <LoginForm
            handleCloseWizard={closeLoginWizard}
          />
          <PasswordResetRequestForm
            handleCloseWizard={closeLoginWizard}
          />
        </StepWizard>
      </StandardModal>
    </>
  );
};

const LoginWizard = () => {
  const { initializeState } = useLoginWizardActions();

  useEffect(() => {
    initializeState();
  }, []);

  return (
    <LoginWizardContent />
  );
};

export default LoginWizard;
